/* eslint-disable */
import Image from "next/image";
import { useState } from "react";
import { shallow } from "zustand/shallow";

import type { LivePriceData } from "@/api/digital-gold/livePrice";
import { useLivePrice } from "@/api/digital-gold/livePrice";
import {
  LivePriceDataIntitial,
  useLivePriceStore,
} from "@/api/digital-gold/store/livePriceStore";
import Clock from "@/assets/images/icons/clock-icon.svg";

import { Timer } from "./Timer";

export const updateLiveDataToStore = () => {
  const { livePriceData } = useLivePrice();
  const updateLivePrice = useLivePriceStore(
    (state) => state.updateLivePrice,
    shallow
  );
  updateLivePrice(livePriceData);
};
export const LiveGold = ({
  option,
  callApi,
}: {
  option: string;
  callApi: boolean;
}) => {
  if (callApi) {
    updateLiveDataToStore();
  }
  const [livePrice, setLivePrice] = useState(null);

  const pricedata: LivePriceData = useLivePriceStore(
    (state) => state.pricedata,
    shallow
  );

  return (
    <div className="livePrice withTime">
      <div className="left">
        <p className="liveChips text--semi text--white">
          <span className="pulsingDot"></span> Live
        </p>
        <p className="text--regular text--black title">
          Buying Price:{" "}
          <span className="text--bold">
            ₹
            {option === "BUY" || option === "SIP"
              ? pricedata.buyGoldRate.toString()
              : pricedata.saleGoldRate.toString()}
            /gm
          </span>
        </p>
      </div>
      <div className="right live-gold_container"
      //  style={{ display: "flex", flexShrink: 0 }}
       >
        <Image 
style={{ color: undefined }} className="img-fluid" src={Clock} alt="clock icon" />
        <p className="text--black text--regular time">
          Valid for:
          <span className="text--bold">
            <Timer setLivePrice={setLivePrice} flowName={option} />
          </span>
        </p>
      </div>
    </div>
  );
};
